// extracted by mini-css-extract-plugin
module.exports = {"partLink":"dependencyItem_partLink__26klb"};